import * as THREE from "three";

function getVerticesInBox(mesh, box) {
  const verticesInBox = [];
  const geometry = mesh.geometry;
  const positionAttribute = geometry.attributes.position;

  // Ensure the mesh's world matrix is up-to-date
  mesh.updateWorldMatrix(true, false);
  const matrixWorld = mesh.matrixWorld;

  const vertex = new THREE.Vector3();

  // Iterate through all vertices in the geometry
  for (let i = 0; i < positionAttribute.count; i++) {
    // Get the vertex position in local space
    vertex.fromBufferAttribute(positionAttribute, i);

    // Transform the vertex to world space
    vertex.applyMatrix4(matrixWorld);

    // Check if the vertex is contained within the box's bounds (now including Z)
    if (box.containsPoint(vertex)) {
      // If it's inside, add a clone of it to our results array
      verticesInBox.push(vertex.clone());
    }
  }

  return verticesInBox;
}

export function createSpatialGrid(mesh, divisions = { x: 4, y: 4, z: 4 }) {
  if (mesh.geometry.CEPH && mesh.userData["invertedStartMatrix"]) {
    return;
  }
  console.log(mesh.name);

  const startTime = Date.now();
  mesh.geometry.computeBoundingBox();
  mesh.updateMatrixWorld(true);
  mesh.updateWorldMatrix(true, true);
  const geom = mesh.geometry
    .clone()
    .applyMatrix4(mesh.parent.parent.matrixWorld);
  const boundingBox = geom.boundingBox;
  const objectSize = new THREE.Vector3().subVectors(
    boundingBox.max,
    boundingBox.min,
  );
  // Handle cases where an axis has zero size to avoid division by zero
  if (divisions.x === 0) divisions.x = 1;
  if (divisions.y === 0) divisions.y = 1;
  if (divisions.z === 0) divisions.z = 1;

  const gridSize = new THREE.Vector3(
    objectSize.x / divisions.x,
    objectSize.y / divisions.y,
    objectSize.z / divisions.z,
  );

  let gridCells = [];
  const positionAttribute = geom.attributes.position;
  const localVertex = new THREE.Vector3();

  for (let i = 0; i < divisions.x; i++) {
    for (let j = 0; j < divisions.y; j++) {
      for (let k = 0; k < divisions.z; k++) {
        const min = new THREE.Vector3(
          boundingBox.min.x + i * gridSize.x,
          boundingBox.min.y + j * gridSize.y,
          boundingBox.min.z + k * gridSize.z,
        );
        const max = new THREE.Vector3().addVectors(min, gridSize);
        const cellBox = new THREE.Box3(min, max);
        // cellBox.applyMatrix4(mesh.matrixWorld);
        gridCells.push({
          box: cellBox,
          originalBox: cellBox.clone(),
          vertexIndices: [],
        });
      }
    }
  }

  // Assign vertex indices to the grid cells they fall into
  for (let i = 0; i < positionAttribute.count; i++) {
    localVertex.fromBufferAttribute(positionAttribute, i);
    for (const cell of gridCells) {
      if (cell.box.containsPoint(localVertex)) {
        cell.vertexIndices.push(i);
        break; // A vertex can only be in one cell
      }
    }
  }

  gridCells = gridCells.filter(cell => cell.vertexIndices.length > 0);
  mesh.geometry.CEPH = gridCells;
  mesh.userData["invertedStartMatrix"] = mesh.matrixWorld.clone().invert();
  console.log(Date.now() - startTime);

  debugBoxs(mesh);

  return mesh.geometry.CEPH;
}

let debugArr = [];
function debugBoxs(object) {
  if (!doesDebug) {
    return;
  }
  for (let index = 0; index < object.geometry.CEPH.length; index++) {
    const element = object.geometry.CEPH[index];

    // A Box3Helper visualizes the bounding box of an object in the scene.
    // You pass the object (in this case, the boxMesh) to the Box3Helper's constructor.
    const boxHelper = new THREE.Box3Helper(element.box, 0xffff00); // 0xffff00 is the color yellow

    // boxHelper.applyMatrix4(object.parent.parent.matrixWorld);

    // To see the helper, you must add it to the scene.
    debugArr.push(boxHelper);

    if (object.name.includes("sim")) {
      object.parent.parent.parent.parent.parent.parent.attach(boxHelper);
    } else {
      object.parent.parent.parent.parent?.attach(boxHelper);
    }
  }
}

export function resetDebugArr() {
  debugArr.forEach(element => {
    element.removeFromParent();
  });
  console.log("reset boxs");

  debugArr = [];
}

export function getIndexVectorPos(object, index) {
  const positionArr = object.geometry.attributes.position.array;
  return new THREE.Vector3(
    positionArr[index * 3],
    positionArr[index * 3 + 1],
    positionArr[index * 3 + 2],
  ).applyMatrix4(object.matrixWorld);
}
export function validateBVHSetup(object) {
  console.log("Has boundsTree?", !!object.geometry.boundsTree);
  console.log("BoundsTree type:", object.geometry.boundsTree?.constructor.name);
  console.log("BoundsTree root exists?", !!object.geometry.boundsTree?.root);

  // Check if raycast method was overridden
  console.log("Raycast method name:", object.raycast.name);
  console.log(
    "Is custom raycast?",
    object.raycast !== THREE.Mesh.prototype.raycast,
  );

  return (
    object.geometry.boundsTree &&
    object.raycast !== THREE.Mesh.prototype.raycast
  );
}
const raycaster = new THREE.Raycaster();
raycaster.layers.enable(1);
raycaster.far = 500;

const maxPenRaycaster = new THREE.Raycaster();
maxPenRaycaster.firstHitOnly = true;
maxPenRaycaster.layers.enable(1);
maxPenRaycaster.far = 15;

const spacingRaycaster = new THREE.Raycaster();
maxPenRaycaster.layers.enable(1);
maxPenRaycaster.far = 100;

const directions = [
  new THREE.Vector3(1, 0, 0),
  new THREE.Vector3(-1, 0, 0),
  new THREE.Vector3(0, 1, 0),
  new THREE.Vector3(0, -1, 0),
];
export function isPointInsideObject(point, object) {
  // .subVectors(getIndexVectorPos(object, 0), point)
  //   .normalize();
  // Arbitrary direction
  if (!object.geometry.boundsTree) {
    prepareBoundingTrees(object.geometry);
  }
  // let result = true;
  let success = 0,
    fail = 0;
  for (
    let directionIndex = 0;
    directionIndex < directions.length;
    directionIndex++
  ) {
    // result = true;
    raycaster.set(point, directions[directionIndex]);
    // validateBVHSetup(object);
    const intersections = raycaster.intersectObject(object, false);

    // console.log(
    //   "Is raycast accelerated?",
    //   object.raycast !== THREE.Mesh.prototype.raycast,
    // );

    /* const neglictedDistance = 0.00015;
    let filteredCount = 0;
    let distance = -Infinity;
    for (let index = 0; index < intersections.length; index++) {
      // console.log(intersections[index].distance, distance);

      if (intersections[index].distance - distance > neglictedDistance) {
        filteredCount++;
        distance = intersections[index].distance;
      }
    } */
    // result = result && intersections.length % 2 === 1;
    intersections.length % 2 === 1 ? success++ : fail++;
  }
  // console.log(
  //   `intersection amount = ${filteredIntersections.length} , original ${intersections.length}`,
  // );

  // if (filteredIntersections.length % 2 === 1) {
  //   const sphere = createSphereAt(point);

  //   filteredIntersections.forEach(element => {
  //     sphere.attach(createSphereAt(element.point, 0.5, 0xff0000));
  //     // console.log(element);
  //   });
  //   sphere.add(createLine(direction));
  //   object.parent.parent.parent.parent.parent.parent.attach(sphere);
  // }

  return success > fail;
}

export function areColliding(objectA, objectB) {
  const CEPHA = objectA.geometry.CEPH;
  const CEPHB = objectB.geometry.CEPH;
  objectA.updateMatrixWorld(true, true);
  objectA.updateWorldMatrix(true);

  objectB.updateMatrixWorld(true, true);
  objectB.updateWorldMatrix(true);

  if (!CEPHA || !CEPHB) {
    return false;
  }
  updateCEPH(objectA);
  updateCEPH(objectB);

  debugBoxs(objectA);
  debugBoxs(objectB);

  for (let indexA = 0; indexA < CEPHA.length; indexA++) {
    const elementA = CEPHA[indexA];
    for (let indexB = 0; indexB < CEPHB.length; indexB++) {
      const elementB = CEPHB[indexB];
      if (elementA.box.intersectsBox(elementB.box)) {
        // console.log("is going in to check");

        for (let pointA = 0; pointA < elementA.vertexIndices.length; pointA++) {
          const vert = getIndexVectorPos(
            objectA,
            elementA.vertexIndices[pointA],
          );
          const isInside = isPointInsideObject(vert, objectB);
          if (isInside) {
            // console.log(objectA.name, objectB.name);
            return true;
          }
        }
      }
    }
  }
  return false;
}

const tempBox_Cashe = new THREE.Box3();
const tempMatrix_Cashe = new THREE.Matrix4();
export function updateCEPH(object) {
  const CEPH = object.geometry.CEPH;

  tempMatrix_Cashe.multiplyMatrices(
    object.matrixWorld,
    object.userData["invertedStartMatrix"],
  );

  for (let index = 0; index < CEPH.length; index++) {
    CEPH[index].box = tempBox_Cashe
      .copy(CEPH[index].originalBox)
      .clone()
      .applyMatrix4(tempMatrix_Cashe);
  }
}

let allPointsToCheck = [];

export function getMaxPenetration(
  objectA,
  objectB,
  direction = false,
  angle = 180,
) {
  allPointsToCheck = [];
  const CEPHA = objectA.geometry.CEPH;
  const CEPHB = objectB.geometry.CEPH;

  objectA.updateMatrixWorld(true, true);
  objectA.updateWorldMatrix(true);

  objectB.updateMatrixWorld(true, true);
  objectB.updateWorldMatrix(true);

  if (!CEPHA || !CEPHB) {
    return false;
  }

  const box1 = new THREE.Box3().setFromObject(objectA); // Get bounding box for the first object
  const box2 = new THREE.Box3().setFromObject(objectB); // Get bounding box for the second object

  // Check if the bounding boxes intersect
  if (!box1.intersectsBox(box2)) {
    return -Infinity;
  }

  if (!direction) {
    direction = new THREE.Vector3(1, 0, 0);
  }
  // console.log(objectA.name, objectB.name);

  updateCEPH(objectA);
  updateCEPH(objectB);

  debugBoxs(objectA);
  debugBoxs(objectB);

  for (let indexA = 0; indexA < CEPHA.length; indexA++) {
    const elementA = CEPHA[indexA];
    for (let indexB = 0; indexB < CEPHB.length; indexB++) {
      const elementB = CEPHB[indexB];
      if (elementA.box.intersectsBox(elementB.box)) {
        // console.log("is going in to check");

        allPointsToCheck.push({
          A: [],
          B: [],
        });
        for (let pointA = 0; pointA < elementA.vertexIndices.length; pointA++) {
          const vert = getIndexVectorPos(
            objectA,
            elementA.vertexIndices[pointA],
          );
          const isInside = isPointInsideObject(vert, objectB);
          if (isInside) {
            allPointsToCheck[allPointsToCheck.length - 1].A.push(
              elementA.vertexIndices[pointA],
            );
            // allPointsToCheck.push({
            //   A: elementA.vertexIndices,
            //   B: elementB.vertexIndices,
            // });
            // break;
          }
        }

        for (let pointB = 0; pointB < elementB.vertexIndices.length; pointB++) {
          const vert = getIndexVectorPos(
            objectB,
            elementB.vertexIndices[pointB],
          );
          const isInside = isPointInsideObject(vert, objectA);
          if (isInside) {
            allPointsToCheck[allPointsToCheck.length - 1].B.push(
              elementB.vertexIndices[pointB],
            );
          }
        }
      }
    }
  }

  let maxDistance = -Infinity;
  let lastPointA, lastPointB;
  for (let index = 0; index < allPointsToCheck.length; index++) {
    const element = allPointsToCheck[index];
    for (let indexA = 0; indexA < element.A.length; indexA++) {
      const pointA = getIndexVectorPos(objectA, element.A[indexA]);
      for (let indexB = 0; indexB < element.B.length; indexB++) {
        const pointB = getIndexVectorPos(objectB, element.B[indexB]);

        const newDistance = getHorizontalDistance(pointA, pointB);
        const holder = pointA.clone().sub(pointB).normalize();
        if (THREE.MathUtils.radToDeg(holder.angleTo(direction)) > angle) {
          continue;
        }

        if (maxDistance < newDistance) {
          lastPointA = pointA;
          lastPointB = pointB;

          maxDistance = newDistance;
        }
      }
    }
  }
  if (doesDebugSphere && lastPointA && lastPointB) {
    objectA.parent.parent.parent.parent.parent.parent.attach(
      createSphereAt(lastPointA, 1, 0xff0000),
    );
    objectA.parent.parent.parent.parent.parent.parent.attach(
      createSphereAt(lastPointB, 1, 0x0000ff),
    );
    // console.log("new distance = ", maxDistance, lastPointA, lastPointB);
  }
  return maxDistance / 10;
}

export function getMaxPenetrationRaycast(objectA, objectB, direction = false) {
  allPointsToCheck = [];
  const CEPHA = objectA.geometry.CEPH;
  const CEPHB = objectB.geometry.CEPH;

  // objectA.updateMatrixWorld(true, true);
  // objectA.updateWorldMatrix(true);

  // objectB.updateMatrixWorld(true, true);
  // objectB.updateWorldMatrix(true);

  if (!CEPHA || !CEPHB) {
    return false;
  }

  const box1 = new THREE.Box3().setFromObject(objectA); // Get bounding box for the first object
  const box2 = new THREE.Box3().setFromObject(objectB); // Get bounding box for the second object

  // Check if the bounding boxes intersect
  if (!box1.intersectsBox(box2)) {
    return -Infinity;
  }

  if (!direction) {
    direction = new THREE.Vector3(1, 0, 0);
  }
  // console.log(objectA.name, objectB.name);

  updateCEPH(objectA);
  updateCEPH(objectB);

  debugBoxs(objectA);
  debugBoxs(objectB);

  for (let indexA = 0; indexA < CEPHA.length; indexA++) {
    const elementA = CEPHA[indexA];
    for (let indexB = 0; indexB < CEPHB.length; indexB++) {
      const elementB = CEPHB[indexB];
      if (elementA.box.intersectsBox(elementB.box)) {
        // console.log("is going in to check");

        allPointsToCheck.push({
          A: [],
        });
        for (let pointA = 0; pointA < elementA.vertexIndices.length; pointA++) {
          const vert = getIndexVectorPos(
            objectA,
            elementA.vertexIndices[pointA],
          );
          if (isPointInsideObject(vert, objectB)) {
            allPointsToCheck[allPointsToCheck.length - 1].A.push(
              elementA.vertexIndices[pointA],
            );
          }
        }
      }
    }
  }

  let maxDistance = -Infinity;
  let lastPointA, lastPointB;
  for (let index = 0; index < allPointsToCheck.length; index++) {
    const element = allPointsToCheck[index];
    for (let indexA = 0; indexA < element.A.length; indexA++) {
      const pointA = getIndexVectorPos(objectA, element.A[indexA]);
      maxPenRaycaster.set(pointA, direction);
      const firstRaycasterResult = maxPenRaycaster.intersectObject(
        objectB,
        false,
      )[0];
      if (firstRaycasterResult) {
        if (maxDistance < firstRaycasterResult.distance) {
          maxDistance = firstRaycasterResult.distance;
        }
      }
    }
  }
  if (doesDebugSphere && lastPointA && lastPointB) {
    objectA.parent.parent.parent.parent.parent.parent.attach(
      createSphereAt(lastPointA, 1, 0xff0000),
    );
    objectA.parent.parent.parent.parent.parent.parent.attach(
      createSphereAt(lastPointB, 1, 0x0000ff),
    );
    // console.log("new distance = ", maxDistance, lastPointA, lastPointB);
  }
  return maxDistance / 10;
}
export function getDistanceBetween(meshA, meshB, direction = false) {
  const CEPHA = meshA.geometry.CEPH;
  const CEPHB = meshB.geometry.CEPH;
  let minDistance = Infinity;

  let closestPair = { a: null, b: null };
  let pairs = [];
  const centerA = new THREE.Vector3();
  const centerB = new THREE.Vector3();

  if (!direction) {
    direction = new THREE.Vector3(1, 0, 0);
  }

  const geomA = meshA.geometry,
    geomB = meshB.geometry;
  if (!geomA.boundingBox) {
    geomA.computeBoundingBox();
  }

  if (!geomB.boundingBox) {
    geomB.computeBoundingBox();
  }

  geomA.boundingBox.getCenter(centerA);
  geomB.boundingBox.getCenter(centerB);

  const baseDistance = centerA.distanceTo(centerB);
  for (let indexA = 0; indexA < CEPHA.length; indexA++) {
    const elementA = CEPHA[indexA];
    elementA.box.getCenter(centerA);
    let currentIterationDistance = baseDistance;
    for (let indexB = 0; indexB < CEPHB.length; indexB++) {
      const elementB = CEPHB[indexB];
      elementB.box.getCenter(centerB);
      const distance = centerA.distanceTo(centerB);

      if (distance < currentIterationDistance) {
        minDistance = distance;
        currentIterationDistance = minDistance;
        closestPair = { a: elementA, b: elementB };
      }
    }
    if (closestPair.a) {
      pairs.push({ a: closestPair.a, b: closestPair.b });
    }
  }

  let lastPointA, lastPointB;
  // console.log(`pairs length = ${pairs.length}`, pairs);

  for (let pairIndex = 0; pairIndex < pairs.length; pairIndex++) {
    closestPair = pairs[pairIndex];

    for (
      let pointA = 0;
      pointA < closestPair.a.vertexIndices.length;
      pointA++
    ) {
      const vertA = getIndexVectorPos(
        meshA,
        closestPair.a.vertexIndices[pointA],
      );

      const isInside = isPointInsideObject(vertA, meshB); // should be removed
      if (isInside) {
        return 0;
      }
      spacingRaycaster.set(vertA, direction);
      const firstRaycasterResult = spacingRaycaster.intersectObject(
        meshB,
        false,
      )[0];
      if (firstRaycasterResult && minDistance > firstRaycasterResult.distance) {
        lastPointA = vertA;
        lastPointB = firstRaycasterResult.point;
        minDistance = firstRaycasterResult.distance;
      }
    }
    if (doesDebugSphere && lastPointA && lastPointB) {
      meshA.parent.parent.parent.parent.parent.parent.attach(
        createSphereAt(lastPointA, 1, 0xff0000),
      );
      meshA.parent.parent.parent.parent.parent.parent.attach(
        createSphereAt(lastPointB, 1, 0x0000ff),
      );
      // console.log("new distance = ", maxDistance, lastPointA, lastPointB);
    }
  }
  if (!Number.isFinite(minDistance)) {
    minDistance = 0;
  }
  return minDistance;
}
const vector2A = new THREE.Vector2(),
  vector2B = new THREE.Vector2();
function getHorizontalDistance(pointA, pointB) {
  vector2A.set(pointA.x, pointA.z);
  vector2B.set(pointB.x, pointB.z);
  // console.log(`angle to is ${vector2A.angleTo(vector2B)}`);

  return vector2A.distanceTo(vector2B);
}

let spheres = [];
let doesDebugSphere = false;

function createSphereAt(position, radius = 1, color = 0xff00ff) {
  const geometry = new THREE.SphereGeometry(radius, 16, 16);
  const material = new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity: 0.25,
  });
  const sphere = new THREE.Mesh(geometry, material);

  sphere.position.copy(position); // Set the position
  spheres.push(sphere);
  return sphere;
}

export function resetSphereArr() {
  spheres.forEach(element => {
    element.removeFromParent();
  });
  console.log("reset spheres");

  spheres = [];
}

function createLine(direction, length = 30, color = 0x00ff00) {
  const geometry = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(),
    direction.normalize().multiplyScalar(length),
  ]);
  const material = new THREE.LineBasicMaterial({
    color, // Red color
    linewidth: 2, // Line width (in pixels)
  });
  const line = new THREE.Line(geometry, material);

  return line;
}
let doesDebug = false;
export function setDebugSqaures() {
  doesDebug = !doesDebug;
  console.log("doesDebug = ", doesDebug);
}
export function setDebugSpheres() {
  doesDebugSphere = !doesDebugSphere;
  console.log("doesDebugSphere = ", doesDebugSphere);
}

function prepareBoundingTrees(geometry) {
  if (!geometry.attributes.position) {
    console.warn("not valid geometry");
    return;
  }
  console.log("actually we are computing");

  geometry.computeBoundsTree({ indirect: true });
}
